import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "question-index",
  "data-test": "question-index",
  tabindex: "0"
}
const _hoisted_2 = {
  id: "question",
  "data-test": "question-text",
  tabindex: "0"
}
const _hoisted_3 = {
  class: "help-text",
  "data-test": "help-text",
  tabindex: "0"
}
const _hoisted_4 = {
  class: "button-container",
  id: "button-container"
}

import {
  IonRadioGroup,
  IonRadio,
  IonList,
  IonLabel,
  IonItem,
  IonCard,
  IonCardContent,
  IonProgressBar,
} from "@ionic/vue";
import { SanityBlocks } from "sanity-blocks-vue-component";
import { chevronForwardOutline, chevronBackOutline } from "ionicons/icons";
import AppButton from "@/components/Common/AppButton/AppButton.vue";
import {
  computed,
  onMounted,
  ref,
  onBeforeMount,
  nextTick,
} from "vue";
import isNumber from "lodash/isNumber";
import { SanityAssessmentItem } from "@/store";

interface Props {
  assessmentItem: SanityAssessmentItem;
  questionIndex: number;
  questionCount: number;
  previousResponse?: number;
  isNextLoading: boolean;
  isPrevLoading: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionWizard',
  props: {
    assessmentItem: {},
    questionIndex: {},
    questionCount: {},
    previousResponse: {},
    isNextLoading: { type: Boolean },
    isPrevLoading: { type: Boolean }
  },
  emits: ["next-click", "prev-click", "save-response"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedResponse = ref();

const progress = computed(() => {
  return props.questionIndex / props.questionCount;
});

const questionAnswered = computed(() => {
  return selectedResponse.value !== undefined;
});

const selectResponse = (ev: CustomEvent | number | undefined) => {
  selectedResponse.value = isNumber(ev) ? ev : ev?.detail.value;
  const label = props.assessmentItem.responses.find(
    (resp: any) => resp.score === selectedResponse.value
  )?.response;
  emit("save-response", {
    index: props.questionIndex - 1,
    score: selectedResponse.value,
    responseLabel: label,
  });
};

onBeforeMount(() => {
  selectedResponse.value = props.previousResponse;
});

onMounted(async () => {
  await nextTick(() => {
    scrollToButtons();
  });
});

const scrollToButtons = (): void => {
  const buttonContainer = document.getElementById("button-container");
  if (buttonContainer) {
    setTimeout(() => {
      buttonContainer.scrollIntoView();
    }, 50);
  }
};

const nextQuestionHandler = () => {
  /* Check that we aren't already loading another question */
  if (!props.isNextLoading) {
    emit("next-click");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("assessment.questionNumber", {
        index: __props.questionIndex,
        count: __props.questionCount,
      })), 1),
    _createVNode(_unref(IonProgressBar), {
      value: progress.value,
      "data-test": "progress-bar",
      "aria-label": "quiz progress bar",
      tabindex: "0"
    }, null, 8, ["value"]),
    _createVNode(_unref(IonCard), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCardContent), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(SanityBlocks), {
                blocks: __props.assessmentItem.item
              }, null, 8, ["blocks"])
            ]),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("assessment.selectYourResponse")) + ": ", 1),
            _createVNode(_unref(IonList), { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonRadioGroup), {
                  value: selectedResponse.value,
                  onIonChange: _cache[0] || (_cache[0] = ($event: any) => (selectResponse($event)))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.assessmentItem.responses, (response, index) => {
                      return (_openBlock(), _createBlock(_unref(IonItem), {
                        class: "response",
                        key: response.score
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), {
                            "data-test": `response-${index}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(response.response), 1)
                            ]),
                            _: 2
                          }, 1032, ["data-test"]),
                          _createVNode(_unref(IonRadio), {
                            class: "response-radio",
                            "label-placement": "start",
                            value: response.score,
                            name: `response-${index}`,
                            "data-test": `radio-${index}`,
                            onKeyup: _withKeys(($event: any) => (selectResponse(response.score)), ["enter"])
                          }, null, 8, ["value", "name", "data-test", "onKeyup"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(AppButton, {
        size: "default",
        type: "primary",
        label: 
        __props.questionIndex < __props.questionCount
          ? _ctx.$t('assessment.next')
          : _ctx.$t('assessment.completeQuiz')
      ,
        ariaLabel: 
        __props.questionIndex < __props.questionCount
          ? _ctx.$t('assessment.next')
          : _ctx.$t('assessment.completeQuiz')
      ,
        icon: _unref(chevronForwardOutline),
        iconPosition: "end",
        disabled: !questionAnswered.value,
        isLoading: __props.isNextLoading,
        onClick: nextQuestionHandler,
        "data-test": "next-button"
      }, null, 8, ["label", "ariaLabel", "icon", "disabled", "isLoading"]),
      (__props.questionIndex > 1)
        ? (_openBlock(), _createBlock(AppButton, {
            key: 0,
            size: "default",
            type: "secondary",
            label: _ctx.$t('assessment.previous'),
            ariaLabel: _ctx.$t('assessment.previous'),
            icon: _unref(chevronBackOutline),
            iconPosition: "start",
            isLoading: __props.isPrevLoading,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('prev-click'))),
            "data-test": "prev-button"
          }, null, 8, ["label", "ariaLabel", "icon", "isLoading"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})